/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=4fa359a7&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=4fa359a7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa359a7"],['__file',"src/pages/tenants/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fa359a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fa359a7', __exports__)) {
    api.reload('4fa359a7', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=4fa359a7&scoped=true", () => {
    api.rerender('4fa359a7', render)
  })

}


export default __exports__